import { render, staticRenderFns } from "./Activesvip.vue?vue&type=template&id=06859db9&scoped=true&"
import script from "./Activesvip.vue?vue&type=script&lang=js&"
export * from "./Activesvip.vue?vue&type=script&lang=js&"
import style0 from "./Activesvip.vue?vue&type=style&index=0&id=06859db9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06859db9",
  null
  
)

export default component.exports